import camelCase from 'lodash/camelCase';
import { TextField } from '@scalingworks/react-admin-ui';
import { InputProps } from '../props';
import { useEffect } from 'react';

export const FormTextField = ({
  input: { item, register, setValue, watch, formState },
}: InputProps) => {
  const { title, name, required, multiline, placeholder, prefix, defaultValue, props, suffix } =
    item;
  const formName = camelCase(name || title);

  const errorMessage = formState?.errors[formName]?.message as string;
  const hasError = !!formState?.errors[formName];

  useEffect(() => {
    if (defaultValue) setValue(formName, defaultValue);
  }, [defaultValue]);

  return (
    <TextField
      {...props}
      required={required}
      prefix={prefix}
      label={title}
      layout="responsive"
      placeholder={placeholder}
      type={multiline ? 'textarea' : undefined}
      defaultValue={defaultValue}
      value={watch(formName)}
      suffix={suffix}
      status={hasError ? 'danger' : undefined}
      renderError={
        hasError ? <div className="text-red-500 text-sm mt-1">{errorMessage}</div> : undefined
      }
      {...register(formName, {
        required: required && 'This field is required',
        pattern: props?.pattern && {
          value: props.pattern,
          message: 'Invalid format',
        },
      })}
      className={multiline ? 'h-24' : ''}
    />
  );
};
